import React, { useEffect, useRef, useState } from "react";
import { Button, Dialog, Divider, FormControlLabel, Radio, RadioGroup } from "@mui/material";
import axios from "axios";
import baseURL from "../../../configs/api";
import AddIcon from "@mui/icons-material/Add";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import LocalSeeIcon from "@mui/icons-material/LocalSee";
import Webcam from "react-webcam";
import SignatureCanvas from "react-signature-canvas";
import AddDriver from "./AddDriver2";
import { format } from "date-fns";
import useAuth from "../../../components/hooks/useAuth";
import { handleCapture } from "../../../utils/covertTheBase64FormatIntoImage";
import { delete_fileUpload, put_fileUpload } from "../../../services/appFileUpload";
import { branchTimezone } from "../../../utils/summaryCalculation";
import { getAvailableVehiclesByVehicleClassIdAndByPickupDateAndReturnDate } from "../../../services/Vehicle";
import { useNavigate } from "react-router-dom";
import FreeVehicleClassChange from "../../../components/common/FreeVehicleClassChange2";
import useConfirm from "../../../components/hooks/useConfirm";
import CustomFormatDatePicker from "../../../components/common/CustomFormatDatePicker";
import { useTheme } from "../../../components/hooks/useTheme";
import colorConfigs from "../../../configs/colorConfigs";
import moment from "moment";
import { CustomImagePopup } from "../../../components/common/CustomImagePopup";
import { cancelPickup, checkoutVehicle, updateFilesAndCommentsApi, updatePickupInfo } from "../../../services/rental";
import Cookies from "js-cookie";
import useTenant from "../../../components/hooks/useTenant";

type CheckoutProps = {
  goToNextPage: (page: number) => void;
  summaryData: any;
  refreshTheSummary: () => void;
  availableVehicle: any[];
  additionalDriver: any[];
  refreshTheAdditionalDriver: () => void;
  signatureURL: any;
  setSignatureURL: (value: any) => void;
  initialsURL: any;
  setInitialsURL: (Value: any) => void;
  refreshTheAttachement: () => void;
  formattedCreatedAt: string;
  securityDepositAmount: number;
  vehicleClassId: number;
  setVehicleClassId: (value: number) => void;
  setSelectedVehiclesClass: (value: any) => void;
  bookedVehicleData: any | null;
  setBookedVehicleData: (value: any) => void;
  pickupDate: string;
  returnDate: string;
  returnTime: string;
  isCompletedOrCancelled: boolean
  pickupLocationOptions: any[];
  checkOutFiles: any[];
  vehicleReplacementCheckOutFiles: any[];
  reservationId: number;
  preferredDateFormat: string;
  selectedVehicleClass: any;
  pleaseWaitPopup: boolean;
  setPleaseWaitPopup: (value: boolean) => void;
};

export const Checkout = ({
  goToNextPage,
  summaryData,
  refreshTheSummary,
  availableVehicle,
  additionalDriver,
  refreshTheAdditionalDriver,
  signatureURL,
  setSignatureURL,
  initialsURL,
  setInitialsURL,
  refreshTheAttachement,
  formattedCreatedAt,
  securityDepositAmount,
  vehicleClassId,
  setVehicleClassId,
  setSelectedVehiclesClass,
  bookedVehicleData,
  setBookedVehicleData,
  pickupDate,
  returnDate,
  returnTime,
  isCompletedOrCancelled,
  pickupLocationOptions,
  checkOutFiles,
  vehicleReplacementCheckOutFiles,
  reservationId,
  preferredDateFormat,
  selectedVehicleClass,
  pleaseWaitPopup,
  setPleaseWaitPopup
}: CheckoutProps) => {
  const tenantId = Cookies.get("tenantId-jj-rental-ui") || "";
  const { themeStyles } = useTheme();
  const { auth }: any = useAuth();
  const { handleTenantError }: any = useTenant();
  const navigate = useNavigate();
  const { setConfirmPopup, setData: setConfirmData }: any = useConfirm();
  const [isContinue, setIsContinue] = useState<boolean>(false);
  const [vehicleId, setVehicleId] = useState<number>(0);
  const [showWebcam, setShowWebcam] = useState<boolean>(false);
  const [filePath, setFilePath] = useState<any[]>([]);
  const [fileIndex, setFileIndex] = useState<number>(-1);
  const [imagePopup, setImagePopup] = useState<boolean>(false);
  const [pickUpDates, setPickUpDate] = useState("");
  const [pickUpTimes, setPickUpTime] = useState("");
  const [pickupLocations, setPickupLocations] = useState<number>(0);
  const [fuelLevelAtCheckOut, setFuelLevelAtCheckOut] = useState<number>(0);
  const [odometerAtCheckOut, setOdometerAtCheckOut] = useState<string>("");
  const [localAddress, setLocalAddress] = useState<string>("");
  const [recalculateRatesOnLatePickup, setRecalculateRatesOnLatePickup] = useState<boolean>(false);
  const [vehicles, setVehicles] = useState<any[]>([]);
  const [isVehiclesDataLoaded, setIsVehiclesDataLoaded] = useState<boolean>(false);
  const [customerId, setCustomerId] = useState<number>(0);
  const [freeVehicleClassChangeOpen, setFreeVehicleClassChangeOpen] = useState<boolean>(false);
  const [isUpdateThePickupInformation, setIsUpdateThePickupInformation] = useState<boolean>(false);
  const [isEdit, setIsEdit] = useState<boolean>(false);

  //Add Driver
  const [driverId, setDriverId] = useState<number>(0);
  const [isPrimaryDriver, setIsPrimaryDriver] = useState<boolean>(false);
  const [addNewDiver, setAddNewDriver] = useState<boolean>(false);
  const [addDriverPopupType, setAddDriverPopupType] = useState<boolean>(true);
  const UpdateTimezone = branchTimezone(formattedCreatedAt);

  useEffect(() => {
    if (summaryData?.isVehicleReplaced) {
      const checkoutOldFiles = vehicleReplacementCheckOutFiles?.filter((item: any) =>
        parseInt(item?.tabName?.replace("Checkout-VehicleReplacement-", "")) === summaryData?.id
      );

      setFilePath(
        checkoutOldFiles?.map((item: any) => ({
          id: item.id,
          fileName: `${baseURL}reservationFile/Get?name=${item.fileName}`
        }))
      );
    } else {
      setFilePath(
        checkOutFiles?.map((item: any) => ({
          id: item.id,
          fileName: `${baseURL}reservationFile/Get?name=${item.fileName}`
        }))
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkOutFiles, vehicleReplacementCheckOutFiles, summaryData])

  useEffect(() => {
    if (summaryData?.vehicleClassId > 0) {
      let latestPickup = moment().format('YYYY-MM-DDTHH:mm');
      let latestReturn = moment().format('YYYY-MM-DDTHH:mm');
      latestPickup = moment(`${summaryData?.pickupDate}`).format('YYYY-MM-DDTHH:mm');
      latestReturn = moment(`${summaryData?.returnDate}`).format('YYYY-MM-DDTHH:mm');

      setVehicles([]);
      getAvailableVehiclesByVehicleClassIdAndByPickupDateAndReturnDate(
        summaryData?.vehicleClassId,
        latestPickup,
        latestReturn,
        tenantId
      )
        .then((data) => {
          setVehicles(
            data?.map((item: any) => {
              return {
                value: item?.id,
                label: item?.name,
                vehicleClassId: item?.vehicleClassId,
                odometer: item?.odometer,
                fuelLevel: item?.fuelLevel,
              };
            })
          );

          setIsVehiclesDataLoaded(true);
          handleTenantError(null);
        })
        .catch((error) => {
          setVehicles([]);
          handleTenantError(error);
        });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [summaryData?.vehicleClassId]);

  useEffect(() => {
    const currentDate = new Date(UpdateTimezone);
    if (summaryData && isVehiclesDataLoaded) {
      setVehicleId(summaryData?.vehicleId ?? 0);
      setOdometerAtCheckOut(summaryData?.odometerAtCheckOut);
      setFuelLevelAtCheckOut(summaryData?.fuelLevelAtCheckOut);
      setPickupLocations(summaryData?.pickupLoationId);
      setRecalculateRatesOnLatePickup(summaryData?.latePickup);
      if (summaryData?.dateTimeCheckOut) {
        setPickUpDate(summaryData?.dateTimeCheckOut?.split("T")[0]);
        setPickUpTime(summaryData?.dateTimeCheckOut?.split("T")[1]);
      } else {
        const initialPickupDate = new Date(summaryData?.pickupDate);
        if (currentDate.getTime() < initialPickupDate?.getTime()) {
          setPickUpDate(initialPickupDate.toISOString().split("T")[0]);
        } else {
          setPickUpDate(moment(currentDate).format("YYYY-MM-DD"));
        }
        setPickUpTime(format(currentDate, "kk:mm"));
      }
      setLocalAddress(summaryData?.localAddress);

      if (bookedVehicleData !== null) {
        setVehicles([...vehicles, {
          value: bookedVehicleData?.id,
          label: bookedVehicleData?.name,
          vehicleClassId: bookedVehicleData?.vehicleClassId,
          odometer: bookedVehicleData?.odometer,
          fuelLevel: bookedVehicleData?.fuelLevel,
        }]);
      }
    }

    setIsContinue(false);

    // eslint-disable-next-line react-hooks/exhaustive-deps    
  }, [summaryData, isVehiclesDataLoaded, bookedVehicleData]);

  const onVehicleChange = (vehicleId: number) => {
    setVehicleId(vehicleId);
    if (vehicleId > 0) {
      setOdometerAtCheckOut(vehicles.find((item: any) => item.value === vehicleId)?.odometer || 0);
      setFuelLevelAtCheckOut(vehicles.find((item: any) => item.value === vehicleId)?.fuelLevel || 0);
    }
  }

  const webRef = useRef(null);
  const inputFileRef = useRef<HTMLInputElement>(null);
  const onFileChangeCapture = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPleaseWaitPopup(true);
    const selectedFiles = e.target.files as FileList;

    if (selectedFiles.length !== 0) {
      const formData = new FormData();
      formData.append("ImageFile", selectedFiles[0]);
      axios
        .post(`${baseURL}reservationFile/upload`, formData, {
          headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "multipart/form-data"
          },
          withCredentials: true,
        })
        .then((response) => {
          let files: any[] = [];

          if (summaryData?.isVehicleReplaced) {
            files.push({
              attributeName: "Reservation",
              attributeId: reservationId,
              fileName: response.data,
              tabName: `Checkout-VehicleReplacement-${summaryData?.id}`,
              userId: auth?.id ?? 0,
              createdDate: new Date(UpdateTimezone).toLocaleString()
            });
          } else {
            files.push({
              attributeName: "Reservation",
              attributeId: reservationId,
              fileName: response.data,
              tabName: "Checkout",
              userId: auth?.id ?? 0,
              createdDate: new Date(UpdateTimezone).toLocaleString()
            });
          }

          uploadTheFiles(files);
          handleTenantError(null);
        })
        .catch((error) => {
          setPleaseWaitPopup(false);
          handleTenantError(error);
        });
    } else {
      setPleaseWaitPopup(false);
    }
  };

  const updateFile = (e: React.ChangeEvent<HTMLInputElement>, id: number) => {
    if (!isCompletedOrCancelled) {
      setPleaseWaitPopup(true);
      const selectedFiles = e.target.files as FileList;
      if (selectedFiles.length !== 0) {
        const formData = new FormData();
        formData.append("ImageFile", selectedFiles[0]);
        axios
          .post(`${baseURL}reservationFile/upload`, formData, {
            headers: {
              'X-Tenant-ID': tenantId,
              "Content-Type": "multipart/form-data"
            },
            withCredentials: true,
          })
          .then((response) => {

            put_fileUpload({
              id,
              attributeName: "Reservation",
              attributeId: reservationId,
              fileName: response.data,
              tabName: summaryData?.isVehicleReplaced ? `Checkout-VehicleReplacement-${summaryData?.id}` : "Checkout",
              userId: auth?.id ?? 0,
              createdDate: new Date(UpdateTimezone).toLocaleString()
            }, auth?.id, tenantId)
              .then(() => {
                setFilePath((prevPath: any[]) =>
                  prevPath.map(file =>
                    file.id === id ? {
                      ...file, fileName: `${baseURL}reservationFile/Get?name=` +
                        response.data,
                    } : file
                  )
                );
                setPleaseWaitPopup(false);
                handleTenantError(null);
              })
              .catch((error) => {
                const errorMessage = error?.response?.data?.message || error?.message || "File upload failed.";
                setConfirmData({
                  title: 'Warning',
                  summary: errorMessage,
                  confirmBtn: 'Ok',
                  isConfirm: (callback: any) => {
                    callback();
                  }
                });
                setConfirmPopup(true);
                setPleaseWaitPopup(false);
                handleTenantError(error);
              })
            handleTenantError(null);
          })
          .catch((error) => {
            setPleaseWaitPopup(false);
            handleTenantError(error);
          });
      } else {
        setPleaseWaitPopup(false);
      }
    }

  }

  let signaturePadRef = React.useRef<SignatureCanvas>(null);
  let initialsPadRef = React.useRef<SignatureCanvas>(null);

  const signatureFileRef = useRef<HTMLInputElement>(null);
  const onSignatureFileChangeCapture = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (!isCompletedOrCancelled) {
      if (!pleaseWaitPopup) {
        setPleaseWaitPopup(true);
        const selectedFiles = e.target.files as FileList;

        if (selectedFiles.length !== 0) {
          const formData = new FormData();
          formData.append("ImageFile", selectedFiles[0]);

          axios
            .post(`${baseURL}reservationFile/upload`, formData, {
              headers: {
                'X-Tenant-ID': tenantId,
                "Content-Type": "multipart/form-data"
              },
              withCredentials: true,
            })
            .then((response) => {
              const newFilePath: any = {
                id: 0,
                fileName: response.data,
              };
              signaturePadRef.current?.clear();
              setSignatureURL(newFilePath);
              setPleaseWaitPopup(false);
              handleTenantError(null);
            })
            .catch((error) => {
              setPleaseWaitPopup(false);
              handleTenantError(error);
            });
        } else {
          setPleaseWaitPopup(false);
        }
      }
    }
  };

  const initialsFileRef = useRef<HTMLInputElement>(null);
  const onInitialsFileChangeCapture = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (!isCompletedOrCancelled) {
      setPleaseWaitPopup(true);
      const selectedFiles = e.target.files as FileList;

      if (selectedFiles.length !== 0) {
        const formData = new FormData();
        formData.append("ImageFile", selectedFiles[0]);

        axios
          .post(`${baseURL}reservationFile/upload`, formData, {
            headers: {
              'X-Tenant-ID': tenantId,
              "Content-Type": "multipart/form-data"
            },
            withCredentials: true,
          })
          .then((response) => {
            const newFilePath: any = {
              id: 0,
              fileName: response.data,
            };

            initialsPadRef.current?.clear();
            setInitialsURL(newFilePath);
            setPleaseWaitPopup(false);
            handleTenantError(null);
          })
          .catch((error) => {
            setPleaseWaitPopup(false);
            handleTenantError(error);
          });
      } else {
        setPleaseWaitPopup(false);
      }
    }
  };

  const calculateAge = (date: string) => {
    var today = new Date();
    var birthDate = new Date(date);
    var age = today.getFullYear() - birthDate.getFullYear();
    var m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  };

  const converTheBase64IntoFileAndUploadToServer = (canvas: HTMLCanvasElement, callback: any) => {
    if (!isCompletedOrCancelled) {
      canvas.toBlob((blob) => {
        if (blob) {
          const formData = new FormData();
          formData.append("ImageFile", blob, 'signature.png');
          axios
            .post(`${baseURL}reservationFile/upload`, formData, {
              headers: {
                'X-Tenant-ID': tenantId,
                "Content-Type": "multipart/form-data"
              },
              withCredentials: true,
            })
            .then((response) => {
              callback(response.data);
              handleTenantError(null);
            })
            .catch((error) => {
              handleTenantError(error);
              callback("");
            });
        } else {
          console.error("Error: Blob is null");
          callback("");
        }
      }, 'image/png');
    }
  }

  const showWarningMessageOnNoImage = () => {
    setConfirmData({
      title: 'Confirm Check Out',
      summary: 'Are you sure you want to continue without image?',
      confirmBtn: 'Continue without image',
      isConfirm: (callback: any) => {
        callback();
        setIsContinue(true);
        confirmCheckOut();
      }
    });

    setTimeout(() => setConfirmPopup(true), 0);
  }

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (!isCompletedOrCancelled) {
      if (isUpdateThePickupInformation && isEdit) {
        setConfirmData({
          title: 'Warning',
          summary: "Are you sure to update pickup information?",
          confirmBtn: 'Ok',
          isConfirm: (callback: any) => {
            callback();
            if (!isContinue && filePath?.length <= 0) {
              showWarningMessageOnNoImage();
              return;
            }

            confirmCheckOut();
          }
        });

        setTimeout(() => setConfirmPopup(true), 0);

      } else if (isUpdateThePickupInformation && !isEdit) {
        setConfirmData({
          title: 'Warning',
          summary: "Please edit pickup information than you can update.",
          confirmBtn: 'Ok',
          isConfirm: (callback: any) => {
            callback();
          }
        });

        setTimeout(() => setConfirmPopup(true), 0);
        return;
      } else {
        if (!isContinue && filePath?.length <= 0) {
          showWarningMessageOnNoImage();
          return;
        }

        confirmCheckOut();
      }
    }
  };

  const confirmCheckOut = () => {
    if (securityDepositAmount !== 0) {
      setConfirmData({
        title: 'Warning',
        summary: 'Please clear the security deposit',
        confirmBtn: 'Ok',
        isConfirm: (callback: any) => {
          callback();
        }
      });

      setTimeout(() => setConfirmPopup(true), 0);
      return;
    }

    if (Number(summaryData?.outstandingBalance) !== 0) {
      setConfirmData({
        title: 'Warning',
        summary: 'Please clear the outstanding balance',
        confirmBtn: 'Ok',
        isConfirm: (callback: any) => {
          callback();
        }
      });

      setTimeout(() => setConfirmPopup(true), 0);
      return;
    }

    if (vehicleId <= 0) {
      setConfirmData({
        title: 'Warning',
        summary: 'Please select the vehicle',
        confirmBtn: 'Ok',
        isConfirm: (callback: any) => {
          callback();
        }
      });

      setTimeout(() => setConfirmPopup(true), 0);
      return;
    }

    if (pickUpDates === "" || pickUpTimes === "") {
      setConfirmData({
        title: 'Warning',
        summary: "Pickup date and time are required",
        confirmBtn: 'Ok',
        isConfirm: async (callback: any) => {
          callback();
        }
      });
      setTimeout(() => setConfirmPopup(true), 0);
      return;
    }

    const initialPickupDate = new Date(summaryData?.pickupDate)?.getTime();
    const pickupDateTime = new Date(`${pickUpDates}T${pickUpTimes}`)?.getTime();
    if (pickupDateTime < initialPickupDate) {
      setConfirmData({
        title: 'Warning',
        summary: "Selected pickup date and time cannot be earlier than the initial pickup date and time.",
        confirmBtn: 'Ok',
        isConfirm: async (callback: any) => {
          callback();
        }
      });
      setTimeout(() => setConfirmPopup(true), 0);
      return;
    }

    const initialReturnDate = new Date(summaryData?.returnDate)?.getTime();

    if (pickupDateTime > initialReturnDate) {
      setConfirmData({
        title: 'Warning',
        summary: "Selected pickup date and time cannot be later than the initial return date and time.",
        confirmBtn: 'Ok',
        isConfirm: async (callback: any) => {
          callback();
        }
      });
      setTimeout(() => setConfirmPopup(true), 0);
      return;
    }

    if (!pleaseWaitPopup) {
      setPleaseWaitPopup(true);

      let files: any[] = [];
      uploadSignature(files);
    }
  }

  const uploadSignature = (files: any[]) => {
    if (!isCompletedOrCancelled) {
      if (signatureURL) {
        if (signatureURL?.id > 0) {
          uploadInitial(files);
          signaturePadRef.current?.clear();
        } else {
          convertAndUploadTheSignature(files);
        }
      } else {
        convertAndUploadTheSignature(files);
      }
    }
  };

  const convertAndUploadTheSignature = (files: any[]) => {
    if (!isCompletedOrCancelled) {
      const canvas = signaturePadRef.current?.getTrimmedCanvas();
      if (canvas && (canvas.width > 1 && canvas.height > 1)) {
        converTheBase64IntoFileAndUploadToServer(canvas, (imageFilePath: string) => {
          if (imageFilePath) {
            files.push({
              attributeName: "Reservation",
              attributeId: reservationId,
              fileName: imageFilePath,
              tabName: "Signature",
              userId: auth?.id ?? 0,
              createdDate: new Date(UpdateTimezone).toLocaleString()
            });

            uploadInitial(files);
            signaturePadRef.current?.clear();
          } else {
            uploadInitial(files);
          }
        });
      } else {
        uploadInitial(files);
      }
    }
  }

  const uploadInitial = (files: any[]) => {
    if (!isCompletedOrCancelled) {
      if (initialsURL) {
        if (initialsURL?.id > 0) {
          updateTheReservation(files);
          initialsPadRef.current?.clear();
        } else {
          convertAndUploadTheInitials(files);
        }
      } else {
        convertAndUploadTheInitials(files);
      }
    }
  };

  const convertAndUploadTheInitials = (files: any[]) => {
    if (!isCompletedOrCancelled) {
      const canvas = initialsPadRef.current?.getTrimmedCanvas();
      if (canvas && (canvas.width > 1 && canvas.height > 1)) {
        converTheBase64IntoFileAndUploadToServer(canvas, (imageFilePath: string) => {
          if (imageFilePath) {
            files.push({
              attributeName: "Reservation",
              attributeId: reservationId,
              fileName: imageFilePath,
              tabName: "Initials",
              userId: auth?.id ?? 0,
              createdDate: new Date(UpdateTimezone).toLocaleString()
            });

            updateTheReservation(files);
            initialsPadRef.current?.clear();
          } else {
            updateTheReservation(files);
          }
        });
      } else {
        updateTheReservation(files);
      }
    }
  }

  const uploadTheFiles = (files: any[]) => {
    updateFilesAndCommentsApi(
      {
        fileUploadDatas: files,
        comments: []
      },
      reservationId,
      auth?.id,
      tenantId
    )
      .then(() => {
        setPleaseWaitPopup(false);
        refreshTheAttachement();
        handleTenantError(null);
      })
      .catch(error => {
        setPleaseWaitPopup(false);
        handleTenantError(error);
      });
  }

  const updateTheReservation = (files: any[]) => {
    if (!isCompletedOrCancelled) {
      if (isUpdateThePickupInformation) {
        updatePickupInfo(
          {
            vehicleId: vehicleId,
            pickupLocationId: pickupLocations,
            fuelLevel: fuelLevelAtCheckOut || 0,
            odometer: odometerAtCheckOut || 0,
            pickupDate: pickUpDates + "T" + pickUpTimes,
            isRecalculateRatesOnLatePickup: recalculateRatesOnLatePickup,
            localAddress: localAddress,
            fileUploadDataDtos: files
          },
          reservationId,
          auth?.id,
          tenantId
        )
          .then(() => {
            refreshTheSummary();
            setIsEdit(false);
            setIsUpdateThePickupInformation(false);
            refreshTheAttachement();
            handleTenantError(null);
          })
          .catch(error => {
            const errorMessage = error?.response?.data?.message || error?.message || "An error occurred while completing the reservation.";
            setConfirmData({
              title: 'Warning',
              summary: errorMessage,
              confirmBtn: 'Ok',
              isConfirm: (callback: any) => {
                callback();
              }
            });

            setConfirmPopup(true);

            setPleaseWaitPopup(false);
            handleTenantError(error);
          })
      } else {
        checkoutVehicle(
          {
            vehicleId: vehicleId,
            pickupLocationId: pickupLocations,
            fuelLevel: fuelLevelAtCheckOut || 0,
            odometer: odometerAtCheckOut || 0,
            pickupDate: pickUpDates + "T" + pickUpTimes,
            isRecalculateRatesOnLatePickup: recalculateRatesOnLatePickup,
            localAddress: localAddress,
            fileUploadDataDtos: files
          },
          reservationId,
          auth?.id,
          tenantId
        )
          .then(() => {
            refreshTheSummary();
            goToNextPage(7);
            setIsEdit(false);
            setIsUpdateThePickupInformation(false);
            refreshTheAttachement();
            handleTenantError(null);
          })
          .catch(error => {
            const errorMessage = error?.response?.data?.message || error?.message || "An error occurred while completing the reservation.";
            setConfirmData({
              title: 'Warning',
              summary: errorMessage,
              confirmBtn: 'Ok',
              isConfirm: (callback: any) => {
                callback();
              }
            });

            setConfirmPopup(true);

            setPleaseWaitPopup(false);
            handleTenantError(error);
          })
      }
    }
  }

  const cancelThePickupInformation = () => {
    if (!isCompletedOrCancelled) {
      setConfirmData({
        title: 'Confirm Cancel pickup information',
        summary: "Are you sure you want to cancel the pickup information?",
        confirmBtn: 'Yes',
        isConfirm: (callback: any) => {
          setPleaseWaitPopup(true);

          cancelPickup(
            reservationId,
            auth?.id,
            tenantId
          )
            .then(() => {
              refreshTheSummary();
              setBookedVehicleData(null);
              handleTenantError(null);
            })
            .catch(error => {
              setPleaseWaitPopup(false);
              handleTenantError(error);
            })

          callback();
        }
      });

      setConfirmPopup(true);
    }
  }

  const deleteTheSignatureURL = async () => {
    if (!isCompletedOrCancelled) {
      setConfirmData({
        title: 'Delete Signature',
        summary: "Are you sure you want to delete this Signature?",
        confirmBtn: 'Yes',
        isConfirm: async (callback: any) => {
          if (signatureURL?.id === 0) {
            setSignatureURL(null);
          } else {
            setPleaseWaitPopup(true);

            await axios
              .delete(`${baseURL}fileUploadData?id=${signatureURL?.id}&userId=${auth?.id}`,
                {
                  headers: {
                    'X-Tenant-ID': tenantId,
                  }
                }
              )
              .then(() => {
                setSignatureURL(null);
                refreshTheAttachement();
                setPleaseWaitPopup(false);
                handleTenantError(null);
              })
              .catch((error) => {
                setPleaseWaitPopup(false);
                handleTenantError(error);
              });
          }
          callback();
        }
      });
      setConfirmPopup(true);
    }
  };

  const deleteTheInitialsURL = async () => {
    if (!isCompletedOrCancelled) {
      setConfirmData({
        title: 'Delete Initials',
        summary: "Are you sure you want to delete this Initials?",
        confirmBtn: 'Yes',
        isConfirm: async (callback: any) => {
          if (initialsURL.id === 0) {
            setInitialsURL(null);
          } else {
            setPleaseWaitPopup(true);

            await axios
              .delete(`${baseURL}fileUploadData?id=${initialsURL?.id}&userId=${auth?.id}`, {
                headers: {
                  'X-Tenant-ID': tenantId,
                }
              })
              .then(() => {
                setInitialsURL(null);
                refreshTheAttachement();
                setPleaseWaitPopup(false);
                handleTenantError(null);
              })
              .catch((error) => {
                setPleaseWaitPopup(false);
                handleTenantError(error);
              });
          }
          callback();
        }
      });
      setConfirmPopup(true);
    }
  };

  return (
    <>
      <div className="w-full">
        <div className={`flex justify-between items-center p-2`}>
          <span className={`text-[14px] font-semibold inline-block mb-2 ${themeStyles.main.textHeadingColor}`}>
            Pickup information
          </span>

          {
            (!isEdit && (summaryData?.status === "Rental" || summaryData?.status === "ReOpen" || summaryData?.status === "Overdue")) && (
              <button className={`px-[8px] py-[6px] bg-transparent shadow-sm rounded-lg border ${themeStyles.main.borderColor} text-white flex items-center gap-1.5`}
                onClick={() => setIsEdit(true)}
              >
                <span className={`material-symbols-outlined text-[25px] font-light ${themeStyles.main.textSubHeadingColor}`}>
                  edit
                </span>
                <span className={`text-xs font-medium ${themeStyles.main.textSubHeadingColor}`}>Edit</span>
              </button>
            )
          }
        </div>

        <Divider className={`w-full ${themeStyles.divider.bg}`} />

        <form onSubmit={handleSubmit}>
          <div className="w-full my-2">
            <div className="w-full px-2">
              <div className="grid grid-cols-2 gap-6 mb-2">
                {
                  (summaryData?.dateTimeCheckOut && !isEdit) ?
                    (
                      <div>
                        <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>Vehicle</span>
                        <br />
                        <span
                          className={`text-xs font-medium hover:underline text-[#0000ff] cursor-pointer`}
                          onClick={() => {
                            if (bookedVehicleData) {
                              navigate("/fleet/vehicle/editvehicles", {
                                state: bookedVehicleData?.id,
                              })
                            }
                          }}
                        >
                          {bookedVehicleData?.name || "--"}
                        </span>
                      </div>
                    ) : (
                      <div>
                        <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Vehicle</label>
                        <select
                          className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                          value={vehicleId}
                          onChange={(e) => onVehicleChange(parseInt(e.target.value))}
                          required
                        >
                          <option className={`${themeStyles.main.tailwindSectionBg}`} value={0}>None</option>
                          {
                            vehicles?.map((item: any, index: number) => {
                              return <option className={`${themeStyles.main.tailwindSectionBg}`} key={index} value={item.value}>{item.label}</option>
                            })
                          }
                        </select>
                      </div>
                    )
                }

                {
                  (summaryData?.dateTimeCheckOut && !isEdit) ?
                    (
                      <div>
                        <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>Pickup Location</span>
                        <br />
                        <span className={`text-xs font-medium ${themeStyles.main.textSubHeadingColor}`}>
                          {pickupLocationOptions?.find((item: any) => item?.id === pickupLocations)?.locationName || "--"}
                        </span>
                      </div>
                    ) : (
                      <div>
                        <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Pickup Location</label>
                        <select
                          className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                          value={pickupLocations}
                          onChange={(e) => setPickupLocations(parseInt(e.target.value))}
                          required
                        >
                          {
                            pickupLocationOptions?.map((item: any, index: number) => {
                              return <option className={`${themeStyles.main.tailwindSectionBg}`} key={index} value={item?.id}>{item?.locationName}</option>
                            })
                          }
                        </select>
                      </div>
                    )}
              </div>

              <div className="grid grid-cols-2 gap-6 mb-2">
                {
                  (summaryData?.dateTimeCheckOut && !isEdit) ?
                    (
                      <div>
                        <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>Fuel Level</span>
                        <br />
                        <span className={`text-xs font-medium ${themeStyles.main.textSubHeadingColor}`}>{fuelLevelAtCheckOut || 0} / 8</span>
                      </div>
                    ) : (
                      <div>
                        <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Fuel Level</label>
                        <select
                          className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                          value={fuelLevelAtCheckOut}
                          onChange={(e) =>
                            setFuelLevelAtCheckOut(parseInt(e.target.value))
                          }
                          required
                        >
                          <option className={`${themeStyles.main.tailwindSectionBg}`} value={0}>0</option>
                          <option className={`${themeStyles.main.tailwindSectionBg}`} value={1}>1</option>
                          <option className={`${themeStyles.main.tailwindSectionBg}`} value={2}>2</option>
                          <option className={`${themeStyles.main.tailwindSectionBg}`} value={3}>3</option>
                          <option className={`${themeStyles.main.tailwindSectionBg}`} value={4}>4</option>
                          <option className={`${themeStyles.main.tailwindSectionBg}`} value={5}>5</option>
                          <option className={`${themeStyles.main.tailwindSectionBg}`} value={6}>6</option>
                          <option className={`${themeStyles.main.tailwindSectionBg}`} value={7}>7</option>
                          <option className={`${themeStyles.main.tailwindSectionBg}`} value={8}>8</option>
                        </select>
                      </div>
                    )
                }

                {
                  (summaryData?.dateTimeCheckOut && !isEdit) ?
                    (
                      <div>
                        <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>Odometer at Pickup</span>
                        <br />
                        <span className={`text-xs font-medium ${themeStyles.main.textSubHeadingColor}`}> {odometerAtCheckOut || 0}</span>
                      </div>
                    ) : (
                      <div>
                        <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Odometer at Pickup</label>
                        <input
                          type="text"
                          inputMode="numeric"
                          className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                          value={odometerAtCheckOut}
                          onChange={(e) => {
                            const value = e.target.value.replace(/\D/g, "");
                            setOdometerAtCheckOut(value);
                          }}
                          onKeyDown={(e) => {
                            const allowedKeys = [
                              "Backspace",
                              "Delete",
                              "ArrowLeft",
                              "ArrowRight",
                              "Tab",
                              "Home",
                              "End",
                            ];

                            if (!allowedKeys.includes(e.key) && !/^\d$/.test(e.key)) {
                              e.preventDefault();
                            }
                          }}
                          onPaste={(e) => {
                            const pasted = e.clipboardData.getData("text");

                            if (!/^\d+$/.test(pasted)) {
                              e.preventDefault();
                            }
                          }}
                          onDrop={(e) => e.preventDefault()}
                          autoComplete="off"
                          required
                        />
                      </div>
                    )
                }
              </div>

              <div className="grid grid-cols-2 gap-6 mb-2">
                {
                  (summaryData?.dateTimeCheckOut && !isEdit) ?
                    (
                      <div>
                        <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>Pickup Date</span>
                        <br />
                        <span className={`text-xs font-medium ${themeStyles.main.textSubHeadingColor}`}>
                          {
                            format(new Date(summaryData?.dateTimeCheckOut), "EEEE, MMMM dd, yyyy")
                          }
                        </span>
                      </div>
                    ) : (
                      <div>
                        <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Pickup Date</label>
                        <CustomFormatDatePicker
                          value={pickUpDates}
                          onChange={setPickUpDate}
                          dateFormat={preferredDateFormat}
                          minDate={summaryData?.pickupDate
                            ? (new Date(summaryData?.pickupDate) === undefined ? moment(new Date(UpdateTimezone)).format("YYYY-MM-DD") : new Date(summaryData?.pickupDate)?.toISOString()?.split("T")[0])
                            : ""}
                          maxDate={summaryData?.returnDate
                            ? (new Date(summaryData?.returnDate) === undefined ? moment(new Date(UpdateTimezone)).format("YYYY-MM-DD") : new Date(summaryData?.returnDate)?.toISOString()?.split("T")[0])
                            : ""}
                          required={true}
                        />
                      </div>
                    )
                }

                {
                  (summaryData?.dateTimeCheckOut && !isEdit)
                    ? (
                      <div className="flex items-center justify-between gap-x-[1rem]">
                        <div>
                          <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>Pickup Time</span>
                          <br />
                          <span className={`text-xs font-medium ${themeStyles.main.textSubHeadingColor}`}>
                            {
                              format(new Date(summaryData?.dateTimeCheckOut), "hh:mm a")
                            }
                          </span>
                        </div>

                        <div className="flex-1">
                          <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>Recalculate rates on late Pickup?</span>
                          <br />
                          <span className={`text-xs font-medium ${themeStyles.main.textSubHeadingColor}`}>{recalculateRatesOnLatePickup ? "Yes" : "No"}</span>
                        </div>
                      </div>
                    ) : (
                      <div className="flex items-center justify-between gap-x-[1rem]">
                        <div className="flex flex-col gap-y-[4px] !mt-[4px]">
                          <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Pickup Time</label>
                          <input
                            type="time"
                            className={`w-fit px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                            value={pickUpTimes}
                            onChange={(e) => setPickUpTime(e.target.value)}
                            required
                          />
                        </div>

                        <div className="flex-1">
                          <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Recalculate rates on late Pickup?</label>
                          <RadioGroup
                            row
                            value={recalculateRatesOnLatePickup ? "Yes" : "No"}
                            onChange={(e) => setRecalculateRatesOnLatePickup(e.target.value === "Yes" ? true : false)}
                          >
                            <FormControlLabel
                              value="Yes"
                              control=
                              {
                                <Radio
                                  sx={{
                                    color: "gray",
                                    "&.Mui-checked": {
                                      color: "#167AC3",
                                    },
                                    '& .MuiSvgIcon-root': {
                                      fontSize: 14,
                                    },
                                  }}
                                />
                              }
                              label="Yes"
                              sx={{
                                color: themeStyles.form.labelTextColor
                              }}
                            />

                            <FormControlLabel
                              value="No"
                              control={
                                <Radio
                                  sx={{
                                    color: "gray",
                                    "&.Mui-checked": {
                                      color: "#167AC3",
                                    },
                                    '& .MuiSvgIcon-root': {
                                      fontSize: 14,
                                    },
                                  }}
                                />
                              }
                              label="No"
                              sx={{
                                color: themeStyles.form.labelTextColor
                              }}
                            />

                          </RadioGroup>
                        </div>
                      </div>
                    )
                }
              </div>
            </div>

            <div className="mt-[16px] w-full">
              {
                (summaryData?.dateTimeCheckOut && !isEdit) ?
                  (
                    <div>
                      <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>Local Address</span>
                      <br />
                      <span className={`text-xs font-medium ${themeStyles.main.textSubHeadingColor}`}>{localAddress || "--"}</span>
                    </div>
                  ) : (
                    <div>
                      <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Local Address</label>
                      <input
                        type="text"
                        className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                        value={localAddress}
                        onChange={(e) => setLocalAddress(e.target.value)}
                      />
                    </div>
                  )
              }
            </div>

            <div className="mt-4 w-full">
              <div className="max-w-1/2 flex flex-row items-center gap-[5px] flex-wrap">
                {
                  filePath.map((item: any, outerIndex: number) => (
                    <React.Fragment key={outerIndex}>
                      <img
                        src={item?.fileName}
                        width={40}
                        height={40}
                        alt="VehicleImage"
                        className="cursor-pointer"
                        onClick={() => {
                          setFileIndex(outerIndex);
                          setImagePopup(true);
                        }}
                      />

                      <RemoveCircleIcon
                        className={`text-[14px] ${themeStyles.main.textSubHeadingColor} font-bold  hover:text-red-500 cursor-pointer`}
                        onClick={() => {
                          if (!isCompletedOrCancelled) {
                            setConfirmData({
                              title: 'Delete image',
                              summary: "Are you sure you want to delete this image?",
                              confirmBtn: 'Yes',
                              isConfirm: (callback: any) => {
                                let newFileSet: any[] = filePath?.filter(
                                  (_, index: number) => index !== outerIndex
                                );

                                if (filePath[outerIndex].id === 0) {
                                  setFilePath(() => newFileSet);
                                } else {
                                  setPleaseWaitPopup(true);

                                  delete_fileUpload(filePath[outerIndex].id, auth?.id, tenantId)
                                    .then(() => {
                                      setFilePath(() => newFileSet);
                                      refreshTheAttachement();
                                      setPleaseWaitPopup(false);
                                      handleTenantError(null);
                                    })
                                    .catch((error) => {
                                      setPleaseWaitPopup(false);
                                      handleTenantError(error);
                                    });
                                }
                                callback();
                              }
                            });
                            setConfirmPopup(true);
                          }
                        }}
                      />
                    </React.Fragment>
                  ))
                }
              </div>

              <div>
                <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Images</label>
                <input
                  type="file"
                  name="inputFileRef"
                  accept="image/*"
                  ref={inputFileRef}
                  className={`hidden`}
                  onChangeCapture={onFileChangeCapture}
                />
                <div className="flex flex-row gap-2 mt-2">
                  <p
                    className="border border-dashed border-black rounded px-2 py-[3px] flex justify-center items-center text-[12px] bg-white cursor-pointer"
                    onClick={() => {
                      if (inputFileRef.current) {
                        inputFileRef.current.value = "";
                      }

                      inputFileRef.current?.click();
                    }}
                  >
                    <AddIcon className="text-[#167AC3] text-[14px] font-bold" />
                    Add Image
                  </p>

                  <p
                    className="border border-dashed border-black rounded px-2 py-[3px] flex justify-center items-center text-[12px] bg-white cursor-pointer"
                    onClick={() => {
                      if (summaryData?.status !== "Open" && isEdit) {
                        setShowWebcam(true);
                      }
                      else {
                        setShowWebcam(true);
                      }
                    }}
                  >
                    <LocalSeeIcon className="text-[#167AC3] text-[14px] font-bold" />
                  </p>
                </div>
              </div>
            </div>
          </div>

          <span className={`text-[14px] font-semibold inline-block my-2 ${themeStyles.main.textHeadingColor}`}>
            Drivers
          </span>

          <Divider className={`w-full ${themeStyles.divider.bg}`} />

          <div className="w-full my-3">
            <table className="min-w-full">
              <tbody className="text-left">
                <tr className={`border-b ${themeStyles.main.borderColor}`}>
                  <th className={`w-[15%] text-[12px] font-semibold mb-2 pr-[0.25rem] py-2 ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>#</th>
                  <th className={`w-[30%] text-[12px] font-semibold mb-2 px-[0.25rem] py-2 ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>Name</th>
                  <th className={`w-[40%] text-[12px] font-semibold mb-2 px-[0.25rem] py-2 ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>Driver License</th>
                  <th className={`w-[10%] text-[12px] font-semibold mb-2 pl-[0.25rem] py-2 ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>Age</th>
                  <th className={`w-[20%] text-[12px] font-semibold mb-2 pl-[0.25rem] py-2 ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>Primary Driver ?</th>
                </tr>

                {
                  additionalDriver?.map((item: any, index: number) => {
                    return (
                      <tr key={index} className={`border-b ${themeStyles.main.borderColor}`}>
                        <td className="pr-[0.25rem] py-2 w-[5%]">
                          <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>{item?.customerId}</span>
                        </td>

                        <td className="px-[0.25rem] py-2 w-[30%]">
                          <span
                            className={`text-xs font-medium underline text-[#0000ff] cursor-pointer`}
                            onClick={() => {
                              if (!isCompletedOrCancelled) {
                                setCustomerId(item?.customerId);
                                setDriverId(parseInt(item?.id));
                                setAddNewDriver(true);
                                setIsPrimaryDriver(item?.primaryDriver);
                                setAddDriverPopupType(false);
                              }
                            }}
                          >
                            {item?.customerName}
                          </span>
                        </td>

                        <td className="px-[0.25rem] py-2 w-[40%]">
                          <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>{item?.idTypeName}</span>
                        </td>

                        <td className="pl-[0.25rem] w-[10%]">
                          <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>{calculateAge(item?.birthday)}</span>
                        </td>

                        <td className="pl-[0.25rem] w-[20%]">
                          <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>{item?.primaryDriver ? "Yes" : "No"}</span>
                        </td>
                      </tr>
                    )
                  })
                }
              </tbody>
            </table>

            <div className="mt-4">
              <Button variant="contained"
                sx={{
                  backgroundColor: colorConfigs.btn.main.bg
                }}
                onClick={() => {
                  if (!isCompletedOrCancelled) {
                    setAddNewDriver(true);
                    setCustomerId(0);
                    setDriverId(0);
                    setIsPrimaryDriver(false);
                    setAddDriverPopupType(true);
                  }
                }}
              >
                Add Driver
              </Button>
            </div>
          </div>

          <span className={`text-[14px] font-semibold inline-block my-2 ${themeStyles.main.textHeadingColor}`}>
            Signatures
          </span>

          <Divider className={`w-full ${themeStyles.divider.bg}`} />

          <div className="w-full my-2 flex gap-2.5">
            <div className="w-1/2 select-none">
              <p className={`text-xs font-bold ${themeStyles.main.textHeadingColor}`}>Signature</p>
              {
                signatureURL
                  ? (
                    <div className="border border-dashed mt-2 border-gray-400 bg-no-repeat bg-center bg-auto">
                      <img src={`${baseURL}reservationFile/Get?name=${signatureURL?.fileName}`} alt="Signature" className="h-[150px]" />
                    </div>
                  ) : (
                    <div className="border border-dashed mt-2 border-gray-400 bg-no-repeat bg-center bg-auto">
                      <SignatureCanvas
                        ref={signaturePadRef}
                        penColor="#167AC3"
                        canvasProps={{
                          className: "w-full h-[150px]",
                        }}
                      />
                    </div>
                  )
              }
              <div className="flex flex-row gap-1 mt-1">
                <i
                  className="bx bxs-eraser text-lg bg-orange-500 text-white px-1.5 py-0.5 rounded cursor-pointer"
                  onClick={() => {
                    if (!isCompletedOrCancelled) {
                      signaturePadRef.current?.clear();
                      if (signatureURL) deleteTheSignatureURL();
                    }
                  }}
                ></i>
                <input
                  type="file"
                  accept="image/*"
                  name="signatureFileRef"
                  ref={signatureFileRef}
                  onChangeCapture={onSignatureFileChangeCapture}
                  className="hidden"
                />
                <i
                  className="bx bx-upload text-lg bg-sky-400 text-white px-1.5 py-0.5 rounded cursor-pointer"
                  onClick={() => {
                    if (!isCompletedOrCancelled) {
                      if (!signatureURL || signatureURL?.id === 0) {
                        signatureFileRef.current?.click();
                      } else {
                        setConfirmData({
                          title: "Warning",
                          summary: "Please remove this Signature first.",
                          confirmBtn: "Ok",
                          isConfirm: (callback: any) => {
                            callback();
                          },
                        });
                        setConfirmPopup(true);
                      }
                    }
                  }}
                ></i>
              </div>
            </div>

            <div className="w-1/2 select-none">
              <p className={`text-xs font-bold ${themeStyles.main.textHeadingColor}`}>Initials</p>
              {
                initialsURL
                  ? (
                    <div className="border border-dashed mt-2 border-gray-400 bg-no-repeat bg-center bg-auto">
                      <img src={`${baseURL}reservationFile/Get?name=${initialsURL?.fileName}`} alt="Initials" className="h-[150px]" />
                    </div>
                  ) : (
                    <div className="border border-dashed mt-2 border-gray-400 bg-no-repeat bg-center bg-auto">
                      <SignatureCanvas
                        ref={initialsPadRef}
                        penColor="#167AC3"
                        canvasProps={{
                          className: "w-full h-[150px]",
                        }}
                      />
                    </div>
                  )
              }

              <div className="flex flex-row gap-1 mt-1">
                <i
                  className="bx bxs-eraser text-lg bg-orange-500 text-white px-1.5 py-0.5 rounded cursor-pointer"
                  onClick={() => {
                    if (!isCompletedOrCancelled) {
                      initialsPadRef.current?.clear();
                      if (initialsURL)
                        deleteTheInitialsURL();
                    }
                  }}
                ></i>
                <input
                  type="file"
                  accept="image/*"
                  name="initialsFileRef"
                  ref={initialsFileRef}
                  onChangeCapture={onInitialsFileChangeCapture}
                  className="hidden"
                />
                <i
                  className="bx bx-upload text-lg bg-sky-400 text-white px-1.5 py-0.5 rounded cursor-pointer"
                  onClick={() => {
                    if (!isCompletedOrCancelled) {
                      if (!initialsURL || initialsURL?.id === 0) {
                        initialsFileRef.current?.click();
                      } else {
                        setConfirmData({
                          title: "Warning",
                          summary: "Please remove this Inititals first.",
                          confirmBtn: "Ok",
                          isConfirm: (callback: any) => {
                            callback();
                          },
                        });
                        setConfirmPopup(true);
                      }
                    }
                  }}
                ></i>
              </div>
            </div>
          </div>

          <div className="w-full mt-4 flex gap-2.5">
            {
              (summaryData?.dateTimeCheckOut)
                ? (
                  <>
                    {
                      summaryData?.status !== "Completed" && (
                        <Button variant="contained"
                          sx={{
                            backgroundColor: colorConfigs.btn.main.bg,
                            fontSize: "10px"
                          }}
                          type="submit"
                          onClick={() => setIsUpdateThePickupInformation(true)}
                        >
                          Update pickup information
                        </Button>
                      )
                    }


                    <Button variant="contained"
                      sx={{
                        backgroundColor: colorConfigs.btn.cancel.bg,
                        border: colorConfigs.btn.cancel.border,
                        color: colorConfigs.btn.cancel.color,
                        fontSize: "10px"
                      }}
                      type="button"
                      onClick={cancelThePickupInformation}
                    >
                      Cancel Pickup
                    </Button>
                  </>
                ) : (
                  <>
                    <Button variant="contained"
                      sx={{
                        backgroundColor: colorConfigs.btn.main.bg,
                        fontSize: "10px"
                      }}
                      type="submit"
                    >
                      Confirm Check Out
                    </Button>

                    <Button variant="contained"
                      sx={{
                        backgroundColor: colorConfigs.btn.main.bg,
                        fontSize: "10px"
                      }}
                      type="button"
                      onClick={() => {
                        if (!isCompletedOrCancelled) {
                          setFreeVehicleClassChangeOpen(true)
                        }
                      }}
                    >
                      Free Vehicle Class Change
                    </Button>
                  </>
                )
            }
          </div>
        </form>
      </div>

      <Dialog
        open={showWebcam}
        maxWidth="md"
        fullScreen={false}
        sx={{
          '& .MuiDialog-paper': {
            maxWidth: '500px',
            width: '100%',
            borderRadius: '16px',
          },
        }}
      >
        <div className={`px-[10px] py-[5px] h-full ${themeStyles.main.tailwindSectionBg}`}>
          <div className={`w-full bg-transparent rounded-lg p-[10px] flex flex-col gap-2.51`}>
            <div className="w-full mt-2">
              <div className={`w-full`}>
                <div className={`flex justify-between items-center p-2 border-b ${themeStyles.main.borderColor}`}>
                  <div className="flex items-center gap-1.5">
                    <h2 className={`text-lg font-semibold ${themeStyles.main.textHeadingColor}`}>WebCam</h2>
                  </div>
                </div>

                <div className="mt-2 p-2">
                  <div className="w-full">
                    <Webcam
                      width={500}
                      height={320}
                      ref={webRef}
                      screenshotFormat="image/png"
                      audio={false}
                    />

                    <div className="flex gap-4 mt-6">
                      <Button variant="contained"
                        sx={{
                          backgroundColor: colorConfigs.btn.cancel.bg,
                          border: colorConfigs.btn.cancel.border,
                          color: colorConfigs.btn.cancel.color
                        }}
                        onClick={() => {
                          if (!isCompletedOrCancelled)
                            setShowWebcam(false)
                        }}>
                        Cancel
                      </Button>

                      <Button variant="contained"
                        sx={{
                          backgroundColor: colorConfigs.btn.main.bg
                        }}
                        onClick={() => {
                          if (webRef.current !== null) {
                            //@ts-ignore
                            const imageSrc = webRef.current.getScreenshot();

                            handleCapture(imageSrc, `${baseURL}reservationFile/upload`, tenantId, (imageFilePath: string) => {
                              if (imageFilePath) {
                                let files: any[] = [];

                                if (summaryData?.isVehicleReplaced) {
                                  files.push({
                                    attributeName: "Reservation",
                                    attributeId: reservationId,
                                    fileName: imageFilePath,
                                    tabName: `Checkout-VehicleReplacement-${summaryData?.id}`,
                                    userId: auth?.id ?? 0,
                                    createdDate: new Date(UpdateTimezone).toLocaleString()
                                  });
                                } else {
                                  files.push({
                                    attributeName: "Reservation",
                                    attributeId: reservationId,
                                    fileName: imageFilePath,
                                    tabName: "Checkout",
                                    userId: auth?.id ?? 0,
                                    createdDate: new Date(UpdateTimezone).toLocaleString()
                                  });
                                }

                                uploadTheFiles(files);
                              }
                            })

                            setShowWebcam(false);
                          }
                        }}
                      >
                        Capture an Image
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Dialog>

      <CustomImagePopup
        showPopup={imagePopup}
        handlePopup={() => setImagePopup(false)}
        filePath={filePath}
        fileIndex={fileIndex}
        setFileIndex={setFileIndex}
        imageBaseUrlPath="reservationFile"
        updateFile={updateFile}
      />

      <AddDriver
        poupType={addDriverPopupType}
        addNewDiver={addNewDiver}
        setAddNewDriver={setAddNewDriver}
        customerId={customerId}
        setCustomerId={setCustomerId}
        drivers={additionalDriver}
        driverId={driverId}
        isPrimaryDriver={isPrimaryDriver}
        setIsPrimaryDriver={setIsPrimaryDriver}
        pickupDate={pickupDate}
        returnDate={returnDate}
        returnTime={returnTime}
        handlePleaseWait={setPleaseWaitPopup}
        refreshTheSummary={() => {
          refreshTheSummary();
          setIsPrimaryDriver(false);
          refreshTheAdditionalDriver();
        }}
        preferredDateFormat={preferredDateFormat}
        selectedVehicleClass={selectedVehicleClass}
        reservationId={reservationId}
      />

      {
        freeVehicleClassChangeOpen && (
          <FreeVehicleClassChange
            freeVehicleClassChangeOpen={freeVehicleClassChangeOpen}
            setFreeVehicleClassChangeOpen={setFreeVehicleClassChangeOpen}
            vehicleClassId={vehicleClassId}
            setVehicleClassId={setVehicleClassId}
            setSelectedVehiclesClass={setSelectedVehiclesClass}
            reservationId={reservationId}
            refreshTheSummary={refreshTheSummary}
            availableVehicle={availableVehicle}
            setPleaseWaitPopup={setPleaseWaitPopup}
          />
        )
      }
    </>
  )
}